var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"group flex items-center px-3 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-gray-50 hover:text-gray-900",attrs:{"to":_vm.to,"exact":_vm.exact,"active-class":"bg-gray-100 text-gray-900 font-semibold"}},[_c('span',{staticClass:"truncate"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }